import { render } from "./InformationModal.vue?vue&type=template&id=3bb29703&ts=true"
import script from "./InformationModal.vue?vue&type=script&lang=ts"
export * from "./InformationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__